<template>
    <div class="Accordion">
        <el-collapse>
            <el-collapse-item :name="node.id" v-for="node of content" :key="node.id">
                <template slot="title">
                    <span>{{ node.title }}</span>
                </template>
                <div v-html="node.content"></div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    export default {
        name:'accordion',
        props: {
            content: Array
        },
        created() {
        }
    }
</script>

<style lang="scss">
    .Accordion {
        display: inline-block;
        width: 100%;
    }
</style>



